import { useEffect, useState } from "react";
import { getUserxId } from "../../../services/user";
import { ErrorContext } from "../../../utils/context/error";
import PropTypes from 'prop-types';

function Avatar({expand}) {
   const [user, setUser] = useState([]);
   const [sigla, setSigla] = useState("");
   const { setShowToast, setOpciones } = ErrorContext();
/**
* trae los datos del usuario que inicia sesion
*/
   const addParametrosUser = async () => {
     let response = await getUserxId();

     if (response) {
       if (response.status === 200) {
           setUser(response.data.data);
           ObtenerSigla(response.data.data?.Nombre1, response.data.data?.Apellido1);
        } else {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
         }
      }
   };
/**
* extrae la primera letra del primer nombre y primer apellido y coloca en el avatar
*/
   const ObtenerSigla = (Nombre, Apellido) => {
      const Sigla = Nombre.charAt(0) + Apellido.charAt(0);
      setSigla(Sigla);
    };
/**
*
*/
   useEffect(() => {
     addParametrosUser();
   }, []);
  return (
    <>
      <div className="fixed bottom-16 md:bottom-14 w-full p-2 flex flex-row items-center justify-center text-center">
         <div className="flex-none">
           <div className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 text-center text-default bg-textsidebar border border-default rounded-full">
             <span className="m-auto font-medium  text-[0.70rem] md:text-sm">{sigla}</span>
           </div>
         </div>
        {expand && (
        <div className="flex-col flex-grow font-medium  text-[0.45rem] md:text-[0.59rem] text-textsidebar">
          <div>
          {user.Nombre1} {user.Apellido1}
          </div>
          <div className="text-sm1 md:text-[0.52rem]">{user.NombreCar}</div>
        </div>
        )}
      </div>
    </>
  );
}
Avatar.propTypes = {
  expand: PropTypes.bool.isRequired,
};
export default Avatar;
